import { postV2ApiCompanyIdUsersManagerAssociations } from 'src/client/spendesk-api';
import {
  type PostV2ApiCompanyIdUsersManagerAssociationsRequest,
  type PostV2ApiCompanyIdUsersManagerAssociationsResponseOK,
} from 'src/client/spendesk-api-types';

export type BulkCreateManagerAssociationPayload = {
  userId: string;
  managerId: string;
}[];

export const postBulkCreateManagerAssociation = async ({
  companyId,
  payload,
}: {
  companyId: string;
  payload: PostV2ApiCompanyIdUsersManagerAssociationsRequest['body']['data'];
}): Promise<PostV2ApiCompanyIdUsersManagerAssociationsResponseOK> => {
  const response = await postV2ApiCompanyIdUsersManagerAssociations({
    body: { data: payload },
    path: { companyId },
  });
  if (response.statusCode === 200) {
    return response.body;
  }

  throw new Error('Creating manager associations failed');
};
